
import AlertUtility from '../../util/AlertUtility';
import TestController from '@/controllers/TestController';
import { inject } from 'vue';
import { Vue } from 'vue-property-decorator';
export default class ExitButton extends Vue {
  private testController: TestController | undefined = inject<TestController>('testController');
  private buttonClicked(): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;
    setTimeout(function () {
      AlertUtility.displayQuestionDialogWithCustomButtonText(that.$t('btn.exit_test'), that.$t('modal.exit_confirm'), that.$t('btn.cancel'), that.$t('btn.ok')).then(() => {
        that.$cookies.remove('qti-player-token');
        that.testController!.reset();
        if (that.testController!.isTestNav) {
          window.location.href = "https://home.testnav.com";
        } else {
          window.location.href = that.testController!.getEndTestRedirect();
        }
      });
    }, 0);
  }
}
